var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlockchain(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.12109 14.2124C8.31059 14.2124 8.48587 14.1265 8.8371 13.9539L11.6605 12.5706C12.9105 11.9581 13.5352 11.6516 13.5352 11.167V5.07617M8.12109 14.2124C7.9316 14.2124 7.75632 14.1265 7.40508 13.9539L4.58165 12.5706C3.33168 11.9581 2.70703 11.6516 2.70703 11.167V5.07617M8.12109 14.2124V8.12158",
    stroke: "#006131",
    strokeWidth: 1.01514,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40508 2.28916C7.757 2.11659 7.93228 2.03064 8.12109 2.03064C8.31059 2.03064 8.48587 2.11659 8.8371 2.28916L11.6605 3.67245C12.9105 4.28492 13.5352 4.59149 13.5352 5.07605C13.5352 5.56061 12.9105 5.86718 11.6605 6.47965L8.8371 7.86294C8.48519 8.03551 8.30991 8.12146 8.12109 8.12146C7.9316 8.12146 7.75632 8.03551 7.40508 7.86294L4.58165 6.47965C3.33168 5.86718 2.70703 5.56061 2.70703 5.07605C2.70703 4.59149 3.33168 4.28492 4.58165 3.67245L7.40508 2.28916Z",
    stroke: "#006131",
    strokeWidth: 1.01514,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockchain);
export default __webpack_public_path__ + "static/media/blockchain.92ec3fc2284f16abe6790b5f2a3f80d4.svg";
export { ForwardRef as ReactComponent };